import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';

@Component({
  selector: 'app-success-dialog',
  templateUrl: './success-dialog.component.html',
  styleUrls: ['./success-dialog.component.scss'],
  standalone: false,
})
export class SuccessDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SuccessDialogComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  closeDialog() {
    this.dialogRef.close();
  }

  goToEstimate() {
    this.router.navigate(['/estimate']);
    this.closeDialog();
  }

  goToDashboard() {
    this.router.navigate(['/dashboard']);
    this.closeDialog();
  }

  goToProjectSetup() {
    let userData = JSON.parse(sessionStorage.getItem('userInfo'));
    let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    let fullTokenPayload = JSON.parse(sessionStorage.getItem('fullTokenPayload'));
    sessionStorage.clear();
    sessionStorage.setItem('userInfo', JSON.stringify(userData));
    sessionStorage.setItem('currentUser', JSON.stringify(currentUser));
    sessionStorage.setItem('fullTokenPayload', JSON.stringify(fullTokenPayload));
    localStorage.setItem('userInfo', JSON.stringify(userData));
    localStorage.setItem('currentUser', JSON.stringify(currentUser));
    localStorage.setItem('fullTokenPayload', JSON.stringify(fullTokenPayload));
    if (this.data.isRRE) {
      this.router.navigate(['/rre-projects']);
    } else {
      this.router.navigate(['/funding-project']);
    }
    this.closeDialog();
  }
}
